import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** 分销计划  批量创建单品通用分销计划 */
export async function batchCreateSingleItemPlansUsingPOST(params: {
    batchCreateSingleItemPlansParam: model.IBatchCreateSingleItemPlansParam;
}) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/batchCreateSingleItemPlans`, {
        ...params.batchCreateSingleItemPlansParam,
    });
    return result;
}

/** 分销计划  创建通用分销计划check */
export async function checkCreatePlanUsingPOST(params: { checkCreatePlanParam: model.ICreatePlanCheckParam }) {
    const result = await axios.post<model.IMessageCheckCreatePlanVO>(`/rest/op/vc/distribution/plan/create/check`, {
        ...params.checkCreatePlanParam,
    });
    return result;
}

/** 分销计划  将计划置为无效 */
export async function invalidateUsingPOST(params: { invalidatePlanParam: model.IInvalidatePlanParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/invalidate`, {
        ...params.invalidatePlanParam,
    });
    return result;
}

/** 分销计划  计划分页查询 */
export async function queryByPageUsingPOST(params: { queryPlanByPageParam: model.IQueryPlanByPageParam }) {
    const result = await axios.post<model.IMessagePlanVoList>(`/rest/op/vc/distribution/plan/queryByPage`, {
        ...params.queryPlanByPageParam,
    });
    return result;
}

/** 分销计划  商品分页查询 */
export async function queryItemByPageUsingPOST(params: { queryItemByPagParam: model.IQueryItemByPagParam }) {
    const result = await axios.post<model.IMessageItemVoList>(`/rest/op/vc/distribution/plan/queryItemByPage`, {
        ...params.queryItemByPagParam,
    });
    return result;
}

/** 分销计划  商品比例查询 */
export async function queryItemRateUsingPOST(params: { queryItemRate: model.IQueryItemRate }) {
    const result = await axios.post<model.IMessageListItemRateVo>(`/rest/op/vc/distribution/plan/queryItemRate`, {
        ...params.queryItemRate,
    });
    return result;
}

/** 分销计划  商品比例查询V2 */
export async function queryItemRateV2UsingPOST(params: { queryItemRate: model.IQueryItemRate }) {
    const result = await axios.post<model.IMessageItemRateVoV2>(`/rest/op/vc/distribution/plan/queryItemRate/v2`, {
        ...params.queryItemRate,
    });
    return result;
}

/** 分销计划  恢复计划 */
export async function resumeUsingPOST(params: { resumePlanParam: model.IResumePlanParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/resume`, {
        ...params.resumePlanParam,
    });
    return result;
}

/** 分销计划  更新计划佣金比例 */
export async function updateRateUsingPOST(params: { updatePlanRateParam: model.IUpdatePlanRateParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/updateRate`, {
        ...params.updatePlanRateParam,
    });
    return result;
}

/** 通用分销计划  删除计划 */
export async function removeUsingPOST(params: { param: model.IRemovePlanParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/remove`, {
        ...params.param,
    });
    return result;
}
